const DisabledSelectOptions = [
   {
      value: 'N',
      label: 'Active',
   },
   {
      value: 'Y',
      label: 'Disabled',
   },
];

export default DisabledSelectOptions;
